import IconCheck from "./IconCheck.vue";
export default IconCheck